import React from 'react'

import MakePaymentValues from 'core/application/adminSignUp/makePayment'
import stateApi, { State } from 'core/application/ichraDecisionTool/prospectSignup/state'
import { Step1Question1Values } from 'core/application/ichraDecisionTool/prospectSignup/step1/question1'
import { Step1Question2Values } from 'core/application/ichraDecisionTool/prospectSignup/step1/question2'

import { BaseNavigationProps } from 'common/wizard/BaseNavigationProps'

import Step1Question1 from './step1/Question1'
import Step1Question2 from './step1/Question2'
import Step2Question1, { Step2Question1Props } from './step2/Question1'
import Step2Question2, { Step2Question2Props } from './step2/Question2'
import Step2Question3, { Step2Question3Props } from './step2/Question3'
import Step2Question4, { Step2Question4Props } from './step2/Question4'
import Step2Question5, { Step2Question5Props } from './step2/Question5'
import Step2Question6, { Step2Question6Props } from './step2/Question6'
import Step3Question1, { Step3Question1Props } from './step3/Question1'

export const ICHRA_DECISION_TOOL_SIGNUP_PATH = 'signup'

export interface NavItemProps {
  key: string
  route: string
  component: React.ComponentType<BaseNavigationProps<any>>
  mapState: (adminSignUpState: State) => any
}

export const RoutesMapping: NavItemProps[] = [
  {
    key: 'ichra-decision-tool-step-1-question-1',
    route: '/get-started',
    component: Step1Question1,
    mapState: (state: State): Step1Question1Values => {
      return {
        companyName: state.prospectInfo.companyName,
        firstName: state.prospectInfo.firstName,
        email: state.prospectInfo.email,
        jobTitle: state.prospectInfo.jobTitle,
        lastName: state.prospectInfo.lastName,
        secondaryEmails: state.prospectInfo.secondaryEmails,
        token: '',
      }
    },
  },
  {
    key: 'ichra-decision-tool-step-1-question-2',
    route: '/insurance-broker',
    component: Step1Question2,
    mapState: (state: State): Step1Question2Values | null => {
      return {
        brokerFirstName: state.insuranceBrokerInfo?.brokerFirstName ?? '',
        brokerLastName: state.insuranceBrokerInfo?.brokerLastName ?? '',
        brokerEmail: state.insuranceBrokerInfo?.brokerEmail ?? '',
        hasInsuranceBroker: state.insuranceBrokerInfo?.hasInsuranceBroker ?? null,
        sendAnalysisToBroker: state.insuranceBrokerInfo?.sendAnalysisToBroker ?? null,
        token: '',
      }
    },
  },
  {
    key: 'ichra-decision-tool-step-2-question-1',
    route: '/current-group-insurance-plan-q1',
    component: Step2Question1,
    mapState: (state: State): Step2Question1Props | null => {
      return {
        currentPlanStatus: state.applicationInfo?.currentPlanStatus ?? null,
        token: '',
        currentPlanStatusOptions: state.applicationInfo?.currentPlanStatusOptions ?? [],
      }
    },
  },
  {
    key: 'ichra-decision-tool-step-2-question-2',
    route: '/current-group-insurance-plan-q2',
    component: Step2Question2,
    mapState: (state: State): Step2Question2Props | null => {
      return {
        whyConsiderAlternatives: state.applicationInfo.whyConsiderAlternatives ?? [],
        whyConsiderAlternativesOther: state.applicationInfo.whyConsiderAlternativesOther ?? null,
        whyConsiderAlternativesOptions: state.applicationInfo.whyConsiderAlternativesOptions ?? [],
        token: '',
      }
    },
  },
  {
    key: 'ichra-decision-tool-step-2-question-3',
    route: '/current-group-insurance-plan-q3',
    component: Step2Question3,
    mapState: (state: State): Step2Question3Props | null => {
      return {
        powerToChooseImportance: state.applicationInfo.powerToChooseImportance ?? null,
        powerToChooseImportanceOptions: state.applicationInfo.powerToChooseImportanceOptions ?? [],
      }
    },
  },
  {
    key: 'ichra-decision-tool-step-2-question-4',
    route: '/current-group-insurance-plan-q4',
    component: Step2Question4,
    mapState: (state: State): Step2Question4Props | null => {
      return {
        coverageOptionsImportance: state.applicationInfo.coverageOptionsImportance ?? null,
        coverageOptionsImportanceOptions: state.applicationInfo.coverageOptionsImportanceOptions ?? [],
      }
    },
  },
  {
    key: 'ichra-decision-tool-step-2-question-5',
    route: '/current-group-insurance-plan-q5',
    component: Step2Question5,
    mapState: (state: State): Step2Question5Props | null => {
      return {
        currentPlanStatus: state.applicationInfo.currentPlanStatus,
        ...state.plans[0],
      }
    },
  },
  {
    key: 'ichra-decision-tool-step-2-question-6',
    route: '/current-group-insurance-plan-q6',
    component: Step2Question6,
    mapState: (state: State): Step2Question6Props | null => {
      return {
        budgetGoal: state.plans[0].budgetGoal,
        currentPlanStatus: state.applicationInfo.currentPlanStatus,
        organizationSpendPerMonth: state.plans[0].organizationSpendPerMonth,
        availableReimbursementOptions: state.plans[0].availableReimbursementOptions,
        budgetGoalsOptions: state.plans[0].budgetGoalsOptions,
        employeeCategoryOptions: state.plans[0].employeeCategoryOptions,
        employeeContributionStrategyOptions: state.plans[0].employeeContributionStrategyOptions,
        id: state.plans[0].id,
      }
    },
  },
  {
    key: 'ichra-decision-tool-step-3-question-1',
    route: '/compare-group-to-ichra-q1',
    component: Step3Question1,
    mapState: (state: State): Step3Question1Props => {
      return {
        companyName: state.prospectInfo.companyName,
      }
    },
  },
]
